import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/manga';

export default function CategoryNav() {
  const [activeCategory, setActiveCategory] = useState('all');

  return (
    <section className="py-4 px-4 md:px-6" aria-label="分类导航">
      <div className="flex items-center gap-2 overflow-x-auto pb-1 scrollbar-hide">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            onClick={() => setActiveCategory(cat.slug)}
            className={`flex items-center gap-1.5 px-4 py-2 text-sm rounded-full whitespace-nowrap transition-all duration-200 cursor-pointer ${
              activeCategory === cat.slug
                ? 'bg-primary-500 text-background-50'
                : 'bg-background-100 text-foreground-600 hover:bg-background-200'
            }`}
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className={`${cat.icon} text-xs`}></i>
            </span>
            {cat.label}
          </Link>
        ))}
      </div>
    </section>
  );
}